import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type InitializeMasterOrderMutationVariables = Types.Exact<{
  input: Types.InitializeMasterOrderInput;
}>;


export type InitializeMasterOrderMutation = { __typename?: 'Mutation', initializeMasterOrder: { __typename?: 'MasterOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, masterOrder?: { __typename?: 'MasterOrderStateData', tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, type: Types.OrderType, status: Types.MasterOrderStatus, salesPerson: string, customer: { __typename?: 'MasterOrderCustomerData', id: string, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'MasterOrderContactData', firstName: string, lastName: string, title: string, type: Types.ContactType, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, masterLineItems: Array<{ __typename?: 'MasterLineItemData', id: string, lineNumber: number, itemId: string, sku: string, itemGroup?: string | null, orderedQuantity?: number | null, scheduledQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, name: string, price: number, upc: string, category?: string | null, eaches: number, addedBy: string, currency: string, dateAdded: Types.TDateISO, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null }>, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }> } | null } };

export type EditMasterOrderMutationVariables = Types.Exact<{
  input: Types.EditMasterOrderInput;
}>;


export type EditMasterOrderMutation = { __typename?: 'Mutation', editMasterOrder: { __typename?: 'MasterOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, masterOrder?: { __typename?: 'MasterOrderStateData', tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, type: Types.OrderType, status: Types.MasterOrderStatus, salesPerson: string, customer: { __typename?: 'MasterOrderCustomerData', id: string, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'MasterOrderContactData', firstName: string, lastName: string, title: string, type: Types.ContactType, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, masterLineItems: Array<{ __typename?: 'MasterLineItemData', id: string, lineNumber: number, itemId: string, sku: string, itemGroup?: string | null, orderedQuantity?: number | null, scheduledQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, name: string, price: number, upc: string, category?: string | null, eaches: number, addedBy: string, currency: string, dateAdded: Types.TDateISO, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null }>, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }> } | null } };

export type AddMasterLineItemsMutationVariables = Types.Exact<{
  input: Types.AddMasterLineItemsInput;
}>;


export type AddMasterLineItemsMutation = { __typename?: 'Mutation', addMasterLineItems: { __typename?: 'MasterOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, masterOrder?: { __typename?: 'MasterOrderStateData', tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, type: Types.OrderType, status: Types.MasterOrderStatus, salesPerson: string, customer: { __typename?: 'MasterOrderCustomerData', id: string, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'MasterOrderContactData', firstName: string, lastName: string, title: string, type: Types.ContactType, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, masterLineItems: Array<{ __typename?: 'MasterLineItemData', id: string, lineNumber: number, itemId: string, sku: string, itemGroup?: string | null, orderedQuantity?: number | null, scheduledQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, name: string, price: number, upc: string, category?: string | null, eaches: number, addedBy: string, currency: string, dateAdded: Types.TDateISO, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null }>, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }> } | null } };

export type UpdateMasterLineItemMutationVariables = Types.Exact<{
  input: Types.UpdateMasterLineItemInput;
}>;


export type UpdateMasterLineItemMutation = { __typename?: 'Mutation', updateMasterLineItem: { __typename?: 'MasterOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, masterOrder?: { __typename?: 'MasterOrderStateData', tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, type: Types.OrderType, status: Types.MasterOrderStatus, salesPerson: string, customer: { __typename?: 'MasterOrderCustomerData', id: string, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'MasterOrderContactData', firstName: string, lastName: string, title: string, type: Types.ContactType, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, masterLineItems: Array<{ __typename?: 'MasterLineItemData', id: string, lineNumber: number, itemId: string, sku: string, itemGroup?: string | null, orderedQuantity?: number | null, scheduledQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, name: string, price: number, upc: string, category?: string | null, eaches: number, addedBy: string, currency: string, dateAdded: Types.TDateISO, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null }>, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }> } | null } };

export type RemoveMasterLineItemMutationVariables = Types.Exact<{
  input: Types.RemoveMasterLineItemInput;
}>;


export type RemoveMasterLineItemMutation = { __typename?: 'Mutation', removeMasterLineItem: { __typename?: 'MasterOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, masterOrder?: { __typename?: 'MasterOrderStateData', tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, type: Types.OrderType, status: Types.MasterOrderStatus, salesPerson: string, customer: { __typename?: 'MasterOrderCustomerData', id: string, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'MasterOrderContactData', firstName: string, lastName: string, title: string, type: Types.ContactType, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, masterLineItems: Array<{ __typename?: 'MasterLineItemData', id: string, lineNumber: number, itemId: string, sku: string, itemGroup?: string | null, orderedQuantity?: number | null, scheduledQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, name: string, price: number, upc: string, category?: string | null, eaches: number, addedBy: string, currency: string, dateAdded: Types.TDateISO, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null }>, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }> } | null } };

export type UpdateMasterOrderStatusMutationVariables = Types.Exact<{
  input: Types.UpdateMasterOrderStatusInput;
}>;


export type UpdateMasterOrderStatusMutation = { __typename?: 'Mutation', updateMasterOrderStatus: { __typename?: 'MasterOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, masterOrder?: { __typename?: 'MasterOrderStateData', tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, type: Types.OrderType, status: Types.MasterOrderStatus, salesPerson: string, customer: { __typename?: 'MasterOrderCustomerData', id: string, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'MasterOrderContactData', firstName: string, lastName: string, title: string, type: Types.ContactType, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, masterLineItems: Array<{ __typename?: 'MasterLineItemData', id: string, lineNumber: number, itemId: string, sku: string, itemGroup?: string | null, orderedQuantity?: number | null, scheduledQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, name: string, price: number, upc: string, category?: string | null, eaches: number, addedBy: string, currency: string, dateAdded: Types.TDateISO, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null }>, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }> } | null } };

export type UpdateMasterAcknowledgedQuantityMutationVariables = Types.Exact<{
  input: Types.UpdateAcknowledgedQuantityMasterItemsInput;
}>;


export type UpdateMasterAcknowledgedQuantityMutation = { __typename?: 'Mutation', updateMasterAcknowledgedQuantity: { __typename?: 'MasterOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, masterOrder?: { __typename?: 'MasterOrderStateData', tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, type: Types.OrderType, status: Types.MasterOrderStatus, salesPerson: string, customer: { __typename?: 'MasterOrderCustomerData', id: string, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'MasterOrderContactData', firstName: string, lastName: string, title: string, type: Types.ContactType, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, masterLineItems: Array<{ __typename?: 'MasterLineItemData', id: string, lineNumber: number, itemId: string, sku: string, itemGroup?: string | null, orderedQuantity?: number | null, scheduledQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, name: string, price: number, upc: string, category?: string | null, eaches: number, addedBy: string, currency: string, dateAdded: Types.TDateISO, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null }>, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }> } | null } };

export type ScheduleMasterOrderWeekMutationVariables = Types.Exact<{
  input: Types.ScheduleMasterOrderWeekInput;
}>;


export type ScheduleMasterOrderWeekMutation = { __typename?: 'Mutation', scheduleMasterOrderWeek: { __typename?: 'ScheduleMasterOrderWeekPayload', orderId: string, outcome: Types.ScheduledWeekOutcome, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateMasterSalesPersonMutationVariables = Types.Exact<{
  input: Types.UpdateMasterOrderSalesPersonInput;
}>;


export type UpdateMasterSalesPersonMutation = { __typename?: 'Mutation', updateMasterSalesPerson: { __typename?: 'MasterOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, masterOrder?: { __typename?: 'MasterOrderStateData', tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, type: Types.OrderType, status: Types.MasterOrderStatus, salesPerson: string, customer: { __typename?: 'MasterOrderCustomerData', id: string, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'MasterOrderContactData', firstName: string, lastName: string, title: string, type: Types.ContactType, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, masterLineItems: Array<{ __typename?: 'MasterLineItemData', id: string, lineNumber: number, itemId: string, sku: string, itemGroup?: string | null, orderedQuantity?: number | null, scheduledQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, name: string, price: number, upc: string, category?: string | null, eaches: number, addedBy: string, currency: string, dateAdded: Types.TDateISO, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null }>, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }> } | null } };


export const InitializeMasterOrderDocument = new TypedDocumentString(`
    mutation InitializeMasterOrder($input: InitializeMasterOrderInput!) {
  initializeMasterOrder(input: $input) {
    errors {
      code
      message
    }
    masterOrder {
      ...MasterOrderDetails
    }
  }
}
    fragment MasterOrderDetails on MasterOrderStateData {
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  type
  status
  salesPerson
  customer {
    ...MasterCustomer
  }
  shipFromLocation {
    name
  }
  masterLineItems {
    ...MasterLineItem
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmails {
    sent
    toEmail
  }
}
fragment MasterCustomer on MasterOrderCustomerData {
  id
  name
  billToAddress {
    ...AddressData
  }
  location {
    ...Location
  }
  contact {
    emailAddress {
      type
      value
    }
    firstName
    lastName
    phoneNumber {
      type
      value
    }
    title
    type
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment MasterLineItem on MasterLineItemData {
  id
  lineNumber
  itemId
  sku
  itemGroup
  orderedQuantity
  scheduledQuantity
  acknowledgedQuantity
  shippedQuantity
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  price
  upc
  category
  eaches
  addedBy
  currency
  dateAdded
}`);
export const EditMasterOrderDocument = new TypedDocumentString(`
    mutation EditMasterOrder($input: EditMasterOrderInput!) {
  editMasterOrder(input: $input) {
    errors {
      code
      message
    }
    masterOrder {
      ...MasterOrderDetails
    }
  }
}
    fragment MasterOrderDetails on MasterOrderStateData {
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  type
  status
  salesPerson
  customer {
    ...MasterCustomer
  }
  shipFromLocation {
    name
  }
  masterLineItems {
    ...MasterLineItem
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmails {
    sent
    toEmail
  }
}
fragment MasterCustomer on MasterOrderCustomerData {
  id
  name
  billToAddress {
    ...AddressData
  }
  location {
    ...Location
  }
  contact {
    emailAddress {
      type
      value
    }
    firstName
    lastName
    phoneNumber {
      type
      value
    }
    title
    type
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment MasterLineItem on MasterLineItemData {
  id
  lineNumber
  itemId
  sku
  itemGroup
  orderedQuantity
  scheduledQuantity
  acknowledgedQuantity
  shippedQuantity
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  price
  upc
  category
  eaches
  addedBy
  currency
  dateAdded
}`);
export const AddMasterLineItemsDocument = new TypedDocumentString(`
    mutation AddMasterLineItems($input: AddMasterLineItemsInput!) {
  addMasterLineItems(input: $input) {
    errors {
      code
      message
    }
    masterOrder {
      ...MasterOrderDetails
    }
  }
}
    fragment MasterOrderDetails on MasterOrderStateData {
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  type
  status
  salesPerson
  customer {
    ...MasterCustomer
  }
  shipFromLocation {
    name
  }
  masterLineItems {
    ...MasterLineItem
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmails {
    sent
    toEmail
  }
}
fragment MasterCustomer on MasterOrderCustomerData {
  id
  name
  billToAddress {
    ...AddressData
  }
  location {
    ...Location
  }
  contact {
    emailAddress {
      type
      value
    }
    firstName
    lastName
    phoneNumber {
      type
      value
    }
    title
    type
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment MasterLineItem on MasterLineItemData {
  id
  lineNumber
  itemId
  sku
  itemGroup
  orderedQuantity
  scheduledQuantity
  acknowledgedQuantity
  shippedQuantity
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  price
  upc
  category
  eaches
  addedBy
  currency
  dateAdded
}`);
export const UpdateMasterLineItemDocument = new TypedDocumentString(`
    mutation UpdateMasterLineItem($input: UpdateMasterLineItemInput!) {
  updateMasterLineItem(input: $input) {
    errors {
      code
      message
    }
    masterOrder {
      ...MasterOrderDetails
    }
  }
}
    fragment MasterOrderDetails on MasterOrderStateData {
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  type
  status
  salesPerson
  customer {
    ...MasterCustomer
  }
  shipFromLocation {
    name
  }
  masterLineItems {
    ...MasterLineItem
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmails {
    sent
    toEmail
  }
}
fragment MasterCustomer on MasterOrderCustomerData {
  id
  name
  billToAddress {
    ...AddressData
  }
  location {
    ...Location
  }
  contact {
    emailAddress {
      type
      value
    }
    firstName
    lastName
    phoneNumber {
      type
      value
    }
    title
    type
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment MasterLineItem on MasterLineItemData {
  id
  lineNumber
  itemId
  sku
  itemGroup
  orderedQuantity
  scheduledQuantity
  acknowledgedQuantity
  shippedQuantity
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  price
  upc
  category
  eaches
  addedBy
  currency
  dateAdded
}`);
export const RemoveMasterLineItemDocument = new TypedDocumentString(`
    mutation RemoveMasterLineItem($input: RemoveMasterLineItemInput!) {
  removeMasterLineItem(input: $input) {
    errors {
      code
      message
    }
    masterOrder {
      ...MasterOrderDetails
    }
  }
}
    fragment MasterOrderDetails on MasterOrderStateData {
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  type
  status
  salesPerson
  customer {
    ...MasterCustomer
  }
  shipFromLocation {
    name
  }
  masterLineItems {
    ...MasterLineItem
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmails {
    sent
    toEmail
  }
}
fragment MasterCustomer on MasterOrderCustomerData {
  id
  name
  billToAddress {
    ...AddressData
  }
  location {
    ...Location
  }
  contact {
    emailAddress {
      type
      value
    }
    firstName
    lastName
    phoneNumber {
      type
      value
    }
    title
    type
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment MasterLineItem on MasterLineItemData {
  id
  lineNumber
  itemId
  sku
  itemGroup
  orderedQuantity
  scheduledQuantity
  acknowledgedQuantity
  shippedQuantity
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  price
  upc
  category
  eaches
  addedBy
  currency
  dateAdded
}`);
export const UpdateMasterOrderStatusDocument = new TypedDocumentString(`
    mutation UpdateMasterOrderStatus($input: UpdateMasterOrderStatusInput!) {
  updateMasterOrderStatus(input: $input) {
    errors {
      code
      message
    }
    masterOrder {
      ...MasterOrderDetails
    }
  }
}
    fragment MasterOrderDetails on MasterOrderStateData {
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  type
  status
  salesPerson
  customer {
    ...MasterCustomer
  }
  shipFromLocation {
    name
  }
  masterLineItems {
    ...MasterLineItem
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmails {
    sent
    toEmail
  }
}
fragment MasterCustomer on MasterOrderCustomerData {
  id
  name
  billToAddress {
    ...AddressData
  }
  location {
    ...Location
  }
  contact {
    emailAddress {
      type
      value
    }
    firstName
    lastName
    phoneNumber {
      type
      value
    }
    title
    type
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment MasterLineItem on MasterLineItemData {
  id
  lineNumber
  itemId
  sku
  itemGroup
  orderedQuantity
  scheduledQuantity
  acknowledgedQuantity
  shippedQuantity
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  price
  upc
  category
  eaches
  addedBy
  currency
  dateAdded
}`);
export const UpdateMasterAcknowledgedQuantityDocument = new TypedDocumentString(`
    mutation UpdateMasterAcknowledgedQuantity($input: UpdateAcknowledgedQuantityMasterItemsInput!) {
  updateMasterAcknowledgedQuantity(input: $input) {
    errors {
      code
      message
    }
    masterOrder {
      ...MasterOrderDetails
    }
  }
}
    fragment MasterOrderDetails on MasterOrderStateData {
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  type
  status
  salesPerson
  customer {
    ...MasterCustomer
  }
  shipFromLocation {
    name
  }
  masterLineItems {
    ...MasterLineItem
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmails {
    sent
    toEmail
  }
}
fragment MasterCustomer on MasterOrderCustomerData {
  id
  name
  billToAddress {
    ...AddressData
  }
  location {
    ...Location
  }
  contact {
    emailAddress {
      type
      value
    }
    firstName
    lastName
    phoneNumber {
      type
      value
    }
    title
    type
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment MasterLineItem on MasterLineItemData {
  id
  lineNumber
  itemId
  sku
  itemGroup
  orderedQuantity
  scheduledQuantity
  acknowledgedQuantity
  shippedQuantity
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  price
  upc
  category
  eaches
  addedBy
  currency
  dateAdded
}`);
export const ScheduleMasterOrderWeekDocument = new TypedDocumentString(`
    mutation ScheduleMasterOrderWeek($input: ScheduleMasterOrderWeekInput!) {
  scheduleMasterOrderWeek(input: $input) {
    errors {
      code
      message
    }
    orderId
    outcome
  }
}
    `);
export const UpdateMasterSalesPersonDocument = new TypedDocumentString(`
    mutation UpdateMasterSalesPerson($input: UpdateMasterOrderSalesPersonInput!) {
  updateMasterSalesPerson(input: $input) {
    errors {
      code
      message
    }
    masterOrder {
      ...MasterOrderDetails
    }
  }
}
    fragment MasterOrderDetails on MasterOrderStateData {
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  type
  status
  salesPerson
  customer {
    ...MasterCustomer
  }
  shipFromLocation {
    name
  }
  masterLineItems {
    ...MasterLineItem
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmails {
    sent
    toEmail
  }
}
fragment MasterCustomer on MasterOrderCustomerData {
  id
  name
  billToAddress {
    ...AddressData
  }
  location {
    ...Location
  }
  contact {
    emailAddress {
      type
      value
    }
    firstName
    lastName
    phoneNumber {
      type
      value
    }
    title
    type
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment MasterLineItem on MasterLineItemData {
  id
  lineNumber
  itemId
  sku
  itemGroup
  orderedQuantity
  scheduledQuantity
  acknowledgedQuantity
  shippedQuantity
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  price
  upc
  category
  eaches
  addedBy
  currency
  dateAdded
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    InitializeMasterOrder: build.mutation<InitializeMasterOrderMutation, InitializeMasterOrderMutationVariables>({
      query: (variables) => ({ document: InitializeMasterOrderDocument, variables })
    }),
    EditMasterOrder: build.mutation<EditMasterOrderMutation, EditMasterOrderMutationVariables>({
      query: (variables) => ({ document: EditMasterOrderDocument, variables })
    }),
    AddMasterLineItems: build.mutation<AddMasterLineItemsMutation, AddMasterLineItemsMutationVariables>({
      query: (variables) => ({ document: AddMasterLineItemsDocument, variables })
    }),
    UpdateMasterLineItem: build.mutation<UpdateMasterLineItemMutation, UpdateMasterLineItemMutationVariables>({
      query: (variables) => ({ document: UpdateMasterLineItemDocument, variables })
    }),
    RemoveMasterLineItem: build.mutation<RemoveMasterLineItemMutation, RemoveMasterLineItemMutationVariables>({
      query: (variables) => ({ document: RemoveMasterLineItemDocument, variables })
    }),
    UpdateMasterOrderStatus: build.mutation<UpdateMasterOrderStatusMutation, UpdateMasterOrderStatusMutationVariables>({
      query: (variables) => ({ document: UpdateMasterOrderStatusDocument, variables })
    }),
    UpdateMasterAcknowledgedQuantity: build.mutation<UpdateMasterAcknowledgedQuantityMutation, UpdateMasterAcknowledgedQuantityMutationVariables>({
      query: (variables) => ({ document: UpdateMasterAcknowledgedQuantityDocument, variables })
    }),
    ScheduleMasterOrderWeek: build.mutation<ScheduleMasterOrderWeekMutation, ScheduleMasterOrderWeekMutationVariables>({
      query: (variables) => ({ document: ScheduleMasterOrderWeekDocument, variables })
    }),
    UpdateMasterSalesPerson: build.mutation<UpdateMasterSalesPersonMutation, UpdateMasterSalesPersonMutationVariables>({
      query: (variables) => ({ document: UpdateMasterSalesPersonDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useInitializeMasterOrderMutation, useEditMasterOrderMutation, useAddMasterLineItemsMutation, useUpdateMasterLineItemMutation, useRemoveMasterLineItemMutation, useUpdateMasterOrderStatusMutation, useUpdateMasterAcknowledgedQuantityMutation, useScheduleMasterOrderWeekMutation, useUpdateMasterSalesPersonMutation } = injectedRtkApi;
